module.exports = __webpack_public_path__ + "img/top.7b4d0c82.svg";